export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M6 10.5H18V13.5H6z\"/></svg>";